<template>
  <div class="ask">
    <button v-if="!open" type="button" class="btn btn-block" @click="open = true">Ask a question</button>
    <div v-else class="ask__panel card">
      <div v-for="(turn, i) in history" :key="i" class="ask__turn" :class="`ask__turn--${turn.role}`">
        <p class="ask__text">{{ turn.text }}</p>
      </div>
      <textarea v-model="question" class="talk ask__input" rows="2" placeholder="“It’s smoking a lot, is that OK?”" :disabled="busy"></textarea>
      <div class="row">
        <button type="button" class="btn btn-primary" :disabled="busy || !question.trim()" @click="send">{{ busy ? 'Thinking…' : 'Ask' }}</button>
        <button type="button" class="btn btn-sm" :disabled="busy" @click="open = false">Close</button>
      </div>
      <p v-if="error" class="ask__error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
// Claude in the kitchen. The Lambda gets the whole lesson and which step
// is on screen, so "is that enough?" has something to refer to. Short
// answers, no recipes rewritten; that is the prompt's job.
import { ref } from 'vue';
import { askQuestion } from '../utils/api.js';

export default {
  name: 'AskBox',
  props: { lesson: { type: Object, required: true }, stepIndex: { type: Number, default: 0 } },
  setup (props) {
    const open = ref(false);
    const question = ref('');
    const history = ref([]);
    const busy = ref(false);
    const error = ref(null);

    async function send () {
      const text = question.value.trim();
      if (!text || busy.value) return;
      busy.value = true;
      error.value = null;
      const priorTurns = history.value.slice(-6);
      history.value.push({ role: 'you', text });
      question.value = '';
      try {
        const { answer } = await askQuestion({ lesson: props.lesson, stepIndex: props.stepIndex, question: text, history: priorTurns });
        history.value.push({ role: 'claude', text: answer });
      } catch (err) {
        error.value = err.message;
        question.value = text;
        history.value.pop();
      } finally {
        busy.value = false;
      }
    }

    return { open, question, history, busy, error, send };
  }
};
</script>

<style scoped>
.ask__panel { display: flex; flex-direction: column; gap: 0.6rem; }
.ask__turn--you .ask__text { background: var(--accent-soft); border-radius: 12px 12px 2px 12px; padding: 0.5rem 0.75rem; margin: 0; align-self: flex-end; }
.ask__turn--claude .ask__text { background: #f1ebe0; border-radius: 12px 12px 12px 2px; padding: 0.5rem 0.75rem; margin: 0; white-space: pre-wrap; }
.ask__input { min-height: 4rem; }
.ask__error { color: var(--danger); margin: 0; font-size: 0.9rem; }
</style>
